import getApiClient from '../../../../plugins/api'

export default {
    setSearchStatus: function(status) {
        this.searchParams.status = status
    },
    changePage: function(page) {
        this.page = page
    },
    checkAccess: function() {
        const requestRole = 'ROLE_AGENCY',
            self = this

        let userRole = ''

        if (self.$store.state.user.roles) {
            userRole = self.$store.state.user.roles[0]
        }

        if (userRole !== requestRole) {
            // self.$router.push('/')
        }
    },

    sortOrders: function(value) {
        this.orderDirection = value.asc ? 'asc' : 'desc'

        let column

        switch(value.column) {
            case 'date':
                column = 'timestamp'
                break
            case 'duration':
                column = 'trip.startTime'
                break
            default:
                column = value.column
        }

        this.orderColumn = column

        this.loadOrders()
    },

    loadOrders: function() {
        const self = this,
            api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        self.searchParams.page = self.page

        if (! self.searchParams.status) {
            self.searchParams.status = [3, 8, 4, 6];
        }

        self.searchParams['trip.startTime[after]'] = null
        self.searchParams['trip.startTime[before]'] = null

        if (self.searchParams.futureTrips) {
            self.searchParams['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.searchParams['trip.startTime[before]'] = new Date()
        }

        if (self.orderColumn && self.orderDirection) {
            delete self.searchParams['order[timestamp]']
            delete self.searchParams['order[trip.startTime]']
            self.searchParams[`order[${self.orderColumn}]`] = self.orderDirection
        }

        self.searchParams['isFake'] = 0

        api.get('agency/orders', {
            params: self.searchParams
        })
            .then((result) => {
                self.orders = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    exportOrders: function() {
        const self = this,
          api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        self.searchParams.page = self.page

        if (! self.searchParams.status) {
            self.searchParams.status = [3, 8, 4, 6];
        }

        self.searchParams['trip.startTime[after]'] = null
        self.searchParams['trip.startTime[before]'] = null

        if (self.searchParams.futureTrips) {
            self.searchParams['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.searchParams['trip.startTime[before]'] = new Date()
        }

        if (self.orderColumn && self.orderDirection) {
            self.searchParams[`order[${self.orderColumn}]`] = self.orderDirection
        }

        self.searchParams['isFake'] = 0

        api.get('/export_orders', {
            params: self.searchParams
        },
        {
            responseType: 'blob'
        })
          .then((result) => {
              const blob = new Blob([result.data], { type: "text/csv" });
              const href = URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', 'Pedidos.csv');
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(href);
          })
          .catch((error) => {
              console.log(error)
          })
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    },

    setPlace: function(data) {
        this.searchParams['trip.place.id'] = data.value
    },

    resetPlace: function() {
        this.searchParams['place.id'] = null
    },

    setTrip: function(data) {
        this.searchParams['trip.id'] = data.value
    },

    resetTrip: function() {
        this.searchParams['trip.id'] = null
    }
}
